export const buttonIconPrimary = 'h-4 w-4 text-white mr-1';
export const buttonIconSecondary = 'h-4 w-4 text-primary mr-1';
